import React from "react";
import { v4 as uuid } from "uuid";

import { usePlayContext } from "../../pages/Play/play-context";
import styles from "./action-lines.module.scss";
import { useActionPath } from "./hooks";
import { ArrowMarker } from "./markers";
import { ActionLineProps } from "./types";

export interface SolidLineProps extends ActionLineProps {
  classicMarkerHead?: boolean;
}

export const SolidLine = ({
  action,
  controlPoints,
  strokeWidth = 0.3,
  classicMarkerHead = false,
  animateable = false,
}: SolidLineProps) => {
  const { color = "#000" } = action;
  const markerEndId = uuid();

  const { pathsWithScales, endTime } = useActionPath({ action, controlPoints });

  const { animationTimerApi } = usePlayContext();
  const { effectiveTime: time } = animationTimerApi;

  return (
    <>
      <ArrowMarker id={markerEndId} color={color} xOffset={2.5} />
      {pathsWithScales.map((path, i) => (
        <g key={i}>
          <path
            d={path.pathString}
            className={styles.actionLine}
            {...(i === pathsWithScales.length - 1 && { markerEnd: `url(#arrow-${markerEndId})` })}
            stroke={color}
            strokeWidth={strokeWidth}
            strokeDasharray={`10000 10000`}
            strokeDashoffset={animateable ? path.scale(time) : 0}
            opacity={animateable && endTime && time >= endTime ? 0.2 : 1}
          />
          <path
            d={path.pathString}
            className={styles.actionLine}
            stroke={color}
            strokeWidth={strokeWidth}
            opacity={0.2}
          />
        </g>
      ))}
    </>
  );
};
